import { render } from "./Regulation.vue?vue&type=template&id=d7012982&scoped=true"
import script from "./Regulation.vue?vue&type=script&lang=js"
export * from "./Regulation.vue?vue&type=script&lang=js"

import "./Regulation.vue?vue&type=style&index=0&id=d7012982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7012982"]])

export default __exports__